export enum DynamicLinkType {
  Campaign = 'campaignid',
  Delivery = 'deliverycampaignid',
  CommercialPlace = 'commercialplaceidargument',
}
